<main id="main" [class.menu-open]="isMenuOpen">
  <!-- Menu -->
  <!-- <app-menu></app-menu> -->
  <!-- Conteúdo -->
  <div class="main-content" id="main-content">
    <section id="cover">
      <div class="container-fluid no-padding">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pull-center">
            <img src="../../assets/images/cover.jpg" alt="Capa CNCST">
          </div>
        </div>
      </div>
    </section>

    <section id="intro">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h2>O que é o Catálogo Nacional de Cursos Superiores de Tecnologia?</h2>
            <p>{{ catalogo.textoCapa }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="axles">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <h2 id="cursoPorEixo" class="text-center">Cursos por Eixo Tecnológico</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="axles">
              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 1 }">
                <img src="../../assets/images/eixos/ambiente-e-saude.jpg" alt="Ambiente e Saúde">
                <span>Ambiente e Saúde</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 2 }">
                <img src="../../assets/images/eixos/controle-e-processos-industriais.jpg"
                  alt="Controle e Processos Industriais">
                <span>Controle e Processos Industriais</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 3 }">
                <img src="../../assets/images/eixos/desenvolvimento-educacional-e-social.jpg"
                  alt="Desenvolvimento Educacional e Social">
                <span>Desenvolvimento Educacional e Social</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 4 }">
                <img src="../../assets/images/eixos/gestao-e-negocios.jpg" alt="Gestão e Negócios">
                <span>Gestão e Negócios</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 5 }">
                <img src="../../assets/images/eixos/informacao-e-comunicacao.jpg" alt="Informação e Comunicação">
                <span>Informação e Comunicação</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 6 }">
                <img src="../../assets/images/eixos/infraestrutura.jpg" alt="Infraestrutura">
                <span>Infraestrutura</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 7 }">
                <img src="../../assets/images/eixos/militar.jpg" alt="Militar">
                <span>Militar</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 8 }">
                <img src="../../assets/images/eixos/producao-alimenticia.jpg" alt="Produção Alimentícia">
                <span>Produção Alimentícia</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 9}">
                <img src="../../assets/images/eixos/producao-cultural-e-design.jpg" alt="Produção Cultural e Design">
                <span>Produção Cultural e Design</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 10 }">
                <img src="../../assets/images/eixos/producao-industrial.jpg" alt="Produção Industrial">
                <span>Produção Industrial</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 11 }">
                <img src="../../assets/images/eixos/recursos-naturais.jpg" alt="Recursos Naturais">
                <span>Recursos Naturais</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 12 }">
                <img src="../../assets/images/eixos/seguranca.jpg" alt="Segurança">
                <span>Segurança</span>
              </a>

              <a class="axle" [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: 13 }">
                <img src="../../assets/images/eixos/turismo-hospitalidade-e-lazer.jpg"
                  alt="Turismo, Hospitalidade e Lazer">
                <span>Turismo, Hospitalidade e Lazer</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <!-- /Conteúdo -->
</main>